export default class TemaService {
  constructor(resource) {
    this._resource = resource;
  }

  get(grupoConteudoId, id) {
    return this._resource.get(`tema/${grupoConteudoId}/${id}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }

  getAll(grupoConteudoId) {
    return this._resource.get(`tema/${grupoConteudoId}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }

  save(item) {
    return this._resource.post(`tema`, item).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }

  edit(item) {
    return this._resource.put(`tema/${item.grupoConteudoId}/${item.id}`, item).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }

  delete(grupoConteudoId, id) {
    return this._resource.delete(`tema/${grupoConteudoId}/${id}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/prova/TemaService.js